import { FunctionComponent, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Option } from '@spike/model';
import clsx from 'clsx';
import LabelField from 'components/UI/LabelField';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import styles from './SelectAppointmentFrequency.module.scss';
import ClickAwayListener from '../UI/ClickAwayListener';

export interface SelectPetsProps {
    id?: string;
    label?: string | JSX.Element;
    name?: string;
    selectedOption?: Option<string>;
    placeholder?: string;
    options: Array<Option<string>>;
    disabled?: boolean;
    className?: string;
    required?: boolean;
    information?: string;
    onSelect: (option: Option<string>, name?: string) => void;
}

export const SelectAppointmentFrequency: FunctionComponent<SelectPetsProps> = props => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const clickCollapseHandler = () => {
        setIsCollapsed(prev => !prev);
    };

    const changeHandler = (idSelected: string) => {
        props.onSelect(props.options.find(option => option.id === idSelected)!, props.name);
    };

    const header = (
        <div className={styles.headerContainer}>
            <div className={styles.textContainer}>
                <span className={clsx(styles.header, { [styles.placeholder]: !props.selectedOption })}>
                    {props.selectedOption ? props.selectedOption.name : props.placeholder}
                </span>
            </div>
            <div className={styles.chevronContainer}>
                <FontAwesomeIcon
                    icon={isCollapsed ? faChevronDown : faChevronUp}
                    color={isCollapsed ? '#7A7A7A' : '#222222'}
                    className={styles.chevron}
                />
            </div>
        </div>
    );

    const list = (
        <div className={styles.listContainer}>
            {props.options.map(opt => (
                <div
                    className={styles.itemContainer}
                    key={opt.id}
                    id={`booking_option_frequency_${opt.id}`}
                    onClick={() => changeHandler(opt.id)}
                >
                    <div className={styles.item}>
                        {opt.name} {opt.description && opt.description}
                    </div>
                </div>
            ))}
        </div>
    );

    const collapsed = (
        <div
            className={clsx(styles.border, styles.collapsedContainer, [styles.optionNotSelected])}
            onClick={clickCollapseHandler}
        >
            {header}
        </div>
    );

    const expanded = (
        <div
            className={clsx(styles.border, styles.expandedContainer)}
            onClick={clickCollapseHandler}
        >
            {header}
            {list}
        </div>
    );

    return (
        <ClickAwayListener onClickAway={() => setIsCollapsed(true)}>
            <div className={clsx(styles.container, props.className)}>
                <LabelField {...props} />
                <div
                    className={styles.dropdownContainer}
                    id="booking_list_frequency"
                >
                    {isCollapsed ? collapsed : expanded}
                </div>
            </div>
        </ClickAwayListener>
    );
};

export default SelectAppointmentFrequency;
